module.exports = __webpack_public_path__ + "img/mobile_map_firenze.3d851474.svg";